<template>
    <div style="display: flex; flex-direction: column; align-items: center; height: 100%; padding: 0 3.5em 35px">
       
        <h1 class="svelte-h1">SCAN QR CODE</h1>
        <div style="
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    max-height: 500px;
                    overflow-y: scroll;
                "
                :class="{'svelte-scroll': isScroll}"
            >
            <p class="svelte-p">
                Point your mobile device camera at the
                <br class="svelte-nyj585">
                QR code below to see this product come to life in
                <br class="svelte-nyj585">
                augmented reality!*
            </p>

            <img :src="imgSrc" alt="" style="width: 250px; height:auto">
            <span class="svelte-span">
                *Augmented reality experience is currently
                <br class="svelte-nyj585">
                supported on the following devices:
                <br class="svelte-nyj585">
                iPhone on iOS 12+
                <br class="svelte-nyj585">
                Android 8.0+ with ARCore 1.9+ support
            </span>
        </div>
        
    </div>
</template>

<script setup>
import { cmsClient, host, apiKey } from "@/assets/apis/config";
import { saveAs } from 'file-saver';

const qrUrl = ref(process.client ? window.location.href : "");
const isScroll = ref(false);

const imgSrc = ref("");
const screenWidth = ref(screen.width);
const screenHeight = ref(screen.height);

watch(screenHeight, ()=> {
    if (screenHeight.value <= 830 && screenWidth.value < 1301) {
        isScroll.value = true;
    } else if (screenHeight.value <= 830) {
        isScroll.value = true;
    } else {
        isScroll.value = false;
    }
},{immediate: true})

const options = {
    width: 300,
    height: 300,
    data: process.client ? window.location.href : "",
    margin: 0,
    qrOptions: { typeNumber: "0", mode: "Byte", errorCorrectionLevel: "Q" },
    imageOptions: { hideBackgroundDots: true, imageSize: 0.4, margin: 0 },
    dotsOptions: { type: "square", color: "#05004d" },
    backgroundOptions: { color: "#ffffff" },
    image: "10cc19bd484118dbcd0a7886a38ceddc.png",
    dotsOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
        linear: true,
        radial: false,
        color1: "#6a1a4c",
        color2: "#6a1a4c",
        rotation: "0",
        },
    },
    cornersSquareOptions: { type: "square", color: "#0e013c" },
    cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
        linear: true,
        radial: false,
        color1: "#000000",
        color2: "#000000",
        rotation: "0",
        },
    },
    cornersDotOptions: { type: "square", color: "#04003d" },
    cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
            linear: true,
            radial: false,
            color1: "#000000",
            color2: "#000000",
            rotation: "0",
        },
    },
    backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
            linear: true,
            radial: false,
            color1: "#ffffff",
            color2: "#ffffff",
            rotation: "0",
        },
    },
};

const getBookQr = () => {
    if (process.client) {
        let token = localStorage.getItem('token');
    
        fetch(
            host +
                '/api/qrs' +
                '?url=' +
                qrUrl.value ,
            {
                headers: {
                    'Content-Type': 'application/pdf',
                    'X-API-KEY': apiKey,
                    'X-AUTH-TOKEN': token,
                },
                responseType: 'blob',
            }
        )
            .then((response) => response.blob())
            .then((blob) => {
                imgSrc.value = URL.createObjectURL(blob);
            });
    }
};
onMounted( () => {
     getBookQr();
})
</script>
<style lang="scss">
.svelte-h1 {
    line-height: 1em;
    padding: 1em .9em .75em;
    margin: 0;
    font-weight: 400;
    text-align: center;
}

.svelte-p {
    display: block;
    font-size: 20px;
    text-align: center;
    line-height: 1.2em;

}

.svelte-span {
    font-weight: 400;
    font-size: 14px;
    line-height: 1.428571429;
    color: #222;
}
.svelte-scroll {
    overflow: scroll;
    height: 250px;
}
</style>
